<template>
  <div class="class-wrapper">
    <apexchart :class="classList" type="radialBar" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  name: "RadialChart",
  props: ["studentList", "groupList"],
  data: function() {
    return {
      classList: 'hidden',
      series: [0],
      chartOptions: {
        chart: {
          height: 200,
          type: 'radialBar',
          fontFamily: 'Roboto, sans-serif'
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '70%',
            },
            dataLabels: {
            name: {
              offsetY: 35,
              color: "#5F0100",
              fontSize: "18px"
            },
            value: {
              offsetY: -10,
              color: "#5F0100",
              fontSize: "54px",
              fontWeight: 'bold',
              show: true
            }
          }
          }
        },
        stroke: {
          lineCap: "round",
        },
        labels: ['Students']
      }
    }
  },
  computed: {
    joinedStudents(){
      var arr = [];
      this.groupList.forEach((item) =>
        arr.push(item.studentList.length)
      );
     var arrSum = arr.reduce(function(a,b){
        return a+b;
      }, 0);
      return this.getPercentage(arrSum);
    },
    seriesData(){
      return this.joinedStudents;
    }
  },
  watch: {
    joinedStudents: function(val) {
      this.series = [val];
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'));
      this.classList = 'revealed'
    });
    this.updateChart();
  },
  methods: {
    updateChart() {
      this.chartOptions = {
       ...this.chartOptions
      }
      this.series = [ this.joinedStudents ]
    },
    getPercentage(joinedStudents){
      return parseInt((100 * joinedStudents) / this.studentList.length);
    }
  }
}
</script>

<style lang="scss">
.hidden {
  display: none;
}
@-moz-document url-prefix() {
  .apexcharts-radialbar-area {
    stroke-width: 10;
    transform: scale(1.5) translate(-12%, -4%);
  }
  .apexcharts-text.apexcharts-datalabel-value {
    transform: translate(0, 10%);
    font-size: 36px;
  }
  .apexcharts-text.apexcharts-datalabel-label {
    transform: translate(0, 30%);
  }
}
</style>
